const _ = require('lodash');

// Clients has specific rules
const clients = [
  { nationalId: 1, name: 'nswisa' },
  { nationalId: 2, name: 'dsa' },
  { nationalId: 3, name: 'kanga' },
  { nationalId: 4, name: 'unisyd' },
  { nationalId: 5, name: 'broome' },
  { nationalId: 6, name: 'fencing' },
  { nationalId: 8, name: 'kosovo' },
  { nationalId: 10, name: 'fencingnsw' },
  { nationalId: 11, name: 'utas' },
  { nationalId: 12, name: 'handball' },
  { nationalId: 14, name: 'gridiron' },
  { nationalId: 15, name: 'archery' },
  { nationalId: 16, name: 'creadapticvolleyball' },
  { nationalId: 17, name: 'auckland' },
];

// Clients has specific member rule
const clientNationalIds = _.map(clients, (n) => n.nationalId);

module.exports = {
  clients,
  clientNationalIds
};
